module.exports = __webpack_public_path__ + "static/media/03.ef42ab72.jpg";